import { IBackgroundTaskQueue, IBackgroundTask } from '../../models/backgroundTasks/IBackgroundTaskQueue';

/**
 * @public
 */
export class AsyncBackgroundTaskQueue implements IBackgroundTaskQueue {
  private _queue: IBackgroundTaskQueue | undefined;
  private _buffer: IBackgroundTask[];
  private _loader: (() => Promise<IBackgroundTaskQueue>) | undefined;

  constructor(loader: () => Promise<IBackgroundTaskQueue>) {
    this._buffer = [];

    this._loader = loader;
  }

  public enqueue(task: IBackgroundTask): void {
    if (this._queue) {
      this._queue.enqueue(task);

      return;
    }

    this._buffer.push(task);

    const loader = this._loader;

    if (loader) {
      this._loader = undefined;

      loader().then((queue: IBackgroundTaskQueue) => {
        this._queue = queue;

        for (const bufferedTask of this._buffer.splice(0, Infinity)) {
          queue.enqueue(bufferedTask);
        }
      });
    }
  }
}
